import { motion } from 'framer-motion';
import { Button } from '../ui/button';
import { useNavigate } from 'react-router-dom';
import { Zap, Sparkles } from 'lucide-react';

import { useLanguage } from '../../context/LanguageContext';
const FinalCTASection = ({ language = 'ar', onStartInstant }) => {
  const { localize } = useLanguage();
  const navigate = useNavigate();
  const isAr = language === 'ar';

  return (
    <section
      className="relative py-20 lg:py-28 overflow-hidden bg-gradient-to-br from-indigo-600 via-indigo-700 to-navy-800"
      dir={isAr ? 'rtl' : 'ltr'}
      data-testid="final-cta-section"
    >
      {/* Animated ambient light */}
      <div className="absolute inset-0 opacity-30 pointer-events-none" aria-hidden
           style={{
             background:
               'radial-gradient(600px 400px at 20% 20%, rgba(245,158,11,0.4), transparent 60%),' +
               'radial-gradient(600px 400px at 80% 80%, rgba(129,140,248,0.4), transparent 60%)',
           }} />

      <div className="relative max-w-3xl mx-auto px-6 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="inline-flex items-center gap-1.5 bg-amber-400/20 text-amber-200 text-xs font-bold px-4 py-1.5 rounded-full border border-amber-400/30 mb-6">
            <Sparkles className="w-3.5 h-3.5" />
            {localize({ ar: 'مجاناً حتى سبتمبر 2026', en: 'Free until September 2026' })}
          </div>

          <h2 className="text-3xl lg:text-5xl font-black text-white leading-tight mb-5">
            {localize({ ar: 'ابدأ الآن — بدون انتظار', en: 'Start now — no waiting' })}
          </h2>
          <p className="text-base lg:text-lg text-white/80 mb-10 max-w-xl mx-auto leading-relaxed">
            {localize({ ar: 'مدرّسون متاحون الآن حول مدينتك، مستعدون لمساعدتك في دقائق.', en: 'Tutors are live around your city, ready to help in minutes.' })}
          </p>

          {/* Primary CTA — soft & inviting */}
          <motion.div
            className="relative inline-flex"
            animate={{ y: [0, -2, 0] }}
            transition={{ duration: 3, repeat: Infinity, ease: 'easeInOut' }}
          >
            <motion.span
              className="absolute inset-0 rounded-full bg-amber-400/20 blur-xl"
              animate={{ opacity: [0.3, 0.6, 0.3], scale: [1, 1.08, 1] }}
              transition={{ duration: 3.5, repeat: Infinity, ease: 'easeInOut' }}
              aria-hidden
            />
            <Button
              onClick={() => (onStartInstant ? onStartInstant() : navigate('/student/search?available=true'))}
              className="relative z-10 bg-gradient-to-r from-amber-500 to-orange-500 hover:from-amber-600 hover:to-orange-600 text-white rounded-full px-12 h-14 text-base font-bold shadow-[0_8px_25px_rgba(245,158,11,0.35)] hover:shadow-[0_12px_35px_rgba(245,158,11,0.5)] hover:-translate-y-0.5 transition-all duration-300"
              data-testid="final-cta-btn"
            >
              <Zap className="w-5 h-5 fill-white" />
              {localize({ ar: 'ابدأ درس الآن', en: 'Start a Lesson Now' })}
            </Button>
          </motion.div>

          <p className="mt-6 text-xs text-white/60">
            {localize({ ar: 'بدون التزامات. ألغِ في أي وقت.', en: 'No commitment. Cancel anytime.' })}
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTASection;
